<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
            <el-form-item label="卡号:" prop="gViceNo">
              <el-input  placeholder="" v-model="searchFrom.gViceNo"></el-input>
            </el-form-item>
            <el-form-item label="车牌号:" prop="truckNo">
              <el-input  placeholder="" v-model="searchFrom.truckNo"></el-input>
            </el-form-item>
            <el-form-item label="司机姓名:" prop="driverName">
              <el-input  placeholder="" v-model="searchFrom.driverName"></el-input>
            </el-form-item>
            <el-form-item label="司机电话:" prop="driverTel">
              <el-input  placeholder="" v-model="searchFrom.driverTel"></el-input>
            </el-form-item>
            <el-form-item label="分配类型:" prop="assignType">
                <el-select  v-model="searchFrom.assignType"   placeholder="请选择">
                  <el-option label="分配" value="10"></el-option>
                  <el-option label="圈回" value="20"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="分配时间:" prop="createTime">
             <el-date-picker
                v-model="searchFrom.createTimes"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                 @change="dateChange"
              ></el-date-picker>
               </el-form-item> -->
            <el-form-item label="分配时间:" prop="createTime">
             <el-date-picker
                v-model="searchFrom.createTimes"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="运单号:" prop="businessNo">
              <el-input  placeholder="" v-model="searchFrom.businessNo"></el-input>
            </el-form-item>
            </div>
          </div>
            <div class="searchBtnBox">
              <el-form-item>
                <el-button type="primary"  @click="searchFn" v-if="btnFlg[0]">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="exportFn"  :disabled="isDisable" v-if="btnFlg[1]">导出</el-button>
              </el-form-item>
              <el-form-item>
                <p class="margin0">总金额合计：<span class="red">{{AllData.total}}</span>元</p>
              </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="gViceNo"  min-width="200" :formatter="emptyFn" label="卡号"></el-table-column>
        <el-table-column prop="truckNo"  min-width="160" :formatter="emptyFn" label="车牌号"></el-table-column>
        <el-table-column prop="driverTel"  min-width="160" :formatter="emptyFn" label="司机电话"></el-table-column>
        <el-table-column prop="driverName"  min-width="160" :formatter="emptyFn" label="司机姓名"></el-table-column>
        <el-table-column prop="assignAmount"  width="150" :formatter="emptyFn" label="分配金额（元）"></el-table-column>
        <el-table-column prop="rewardAmount"  width="150" :formatter="emptyFn" label="奖励金额（元）"></el-table-column>
        <el-table-column prop="assignTotalAmount"  width="150" :formatter="emptyFn" label="总金额（元）"></el-table-column>
        <el-table-column prop="assignType"  width="150" :formatter="statusFormat" label="分配类型"></el-table-column>
        <el-table-column prop="businessNo"  min-width="200" :formatter="emptyFn" label="运单号"></el-table-column>
        <el-table-column prop="createUserName"  min-width="150" :formatter="emptyFn" label="分配人"></el-table-column>
        <el-table-column prop="createTime"  min-width="180" :formatter="dateTimeFormat" label="分配时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { assignRecardList, getTotalMoney } from '@/api/consignment'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    return {
      startDatr: null,
      endDate: null,
      AllData: {
        total: ''
      },
      isDisable: false,
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        createTimes: null
      },
      total: 0,
      loading: false,
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['00JM130100', '00JM130200']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/oilgasConsume')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
    function timestampToTime (time) {
      var date = new Date(time)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return Y + M + D
    };
    // this.startDatr = timestampToTime(new Date().getTime() - 1000 * 60 * 60 * 24 * 30)
    this.startDatr = timestampToTime(new Date().setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1)))
    this.endDate = timestampToTime(new Date().getTime())
    this.searchFrom.createTimes = [this.startDatr, this.endDate]

    assignRecardList(this.searchFrom).then(res => {
      this.loading = false
      this.tableList = res.list
      this.total = res.total
    })
    getTotalMoney({ createTimes: this.searchFrom.createTimes }).then(res => {
      this.AllData.total = res
    })
  },
  methods: {
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case '10':
          return '分配'
        case '20':
          return '圈回'
      }
    },
    // dateChange () {
    //   assignRecardList(this.searchFrom).then(res => {
    //     this.loading = false
    //     this.tableList = res.list
    //     this.total = res.total
    //   })
    // },
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.payServer + '/gCardAssignRecard/exportAssignRecardList',
        form,
        '油气充值记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      assignRecardList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: [this.startDatr, this.endDate]
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
</style>
